module.exports = __webpack_public_path__ + "images/on-promo-blue-707f7b31.svg";